function timeSince(date) {
  const timeDiff = new Date() - date;
  const seconds = Math.floor(timeDiff / 1000);
  if (timeDiff < 60000) {
    return { description: "just now", timeout: timeDiff };
  }
  const periods = [
    ["year", 365 * 24 * 60 * 60],
    ["month", 4.34 * 7 * 24 * 60 * 60],
    ["week", 7 * 24 * 60 * 60],
    ["day", 24 * 60 * 60],
    ["hour", 60 * 60],
    ["minute", 60],
  ];
  for (let i = 0; i < periods.length; i++) {
    const [name, period] = periods[i];
    const interval = Math.floor(seconds / period);
    if (interval >= 1) {
      return {
        description: `${interval} ${name}${interval === 1 ? "" : "s"} ago`,
        timeout: timeDiff,
      };
    }
  }

  return { description: "", timeout: 0 };
}

export default timeSince;
